import { Controller } from "@hotwired/stimulus";

// Gates the Edit Plan "Update Plan" submit button: disabled until the customer
// changes their plan, then enabled. Wired on the form so any input/change (recipe,
// interval) and the account-plan-type:changed event (the plan-type toggle sets its
// value via JS and fires no native change) re-enable it. Gives non-half-plan users
// the same behavior half-plan users already got from account-plan-type. The open
// value starts it enabled when the server already changed the plan (an aged dog).
export default class extends Controller {
  static targets = ["submit"];
  static values = { open: Boolean };

  connect() {
    if (this.hasSubmitTarget) this.#setDisabled(!this.openValue);
  }

  enable() {
    if (this.hasSubmitTarget) this.#setDisabled(false);
  }

  #setDisabled(disabled) {
    this.submitTarget.disabled = disabled;
    this.submitTarget.classList.toggle("m-button--disabled", disabled);
  }
}
